<template>
  <div>
    <!------------------------------------------------->
    <!-- TABLE ---------------------------------------->
    <!------------------------------------------------->
    <v-layout wrap>
      <v-flex xs12 pt-4>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('afrus_engine.table.search_by_org')"
                  outlined
                  hide-details
                  @keydown="executeSearch"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table
            :headers="headers"
            :items="stats"
            :search="search"
            :options="pagination"
            :footer-props="{ 'items-per-page-options': [10, 15, 20] }"
            :items-per-page="pagination.itemsPerPage"
            :server-items-length="totalStatsAmount"
            :loading="loading"
            class="elevation-1"
            @click:row="(item) => openDetails(item)"
            @update:options="pagination = $event"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{
                  $t("afrus_engine.table.header_org")
                }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
              </v-toolbar>
            </template>
            <template v-slot:[`item.organization_name`]="{ item }">
              <td>{{ item.organization_name }}</td>
            </template>
            <template v-slot:[`item.organization_id`]="{ item }">
              <div class="d-flex justify-center">{{ item.organization_id }}</div>
            </template>
            <template v-slot:[`item.activeSubscriptions`]="{ item }">
              <div class="d-flex justify-center">{{ item.activeSubscriptions }}</div>
            </template>
            <template v-slot:[`item.effectiveCharges`]="{ item }">
              <div class="d-flex justify-center">{{ item.effectiveCharges }}</div>
            </template>
            <template v-slot:[`item.pendingSubscriptions`]="{ item }">
              <div class="d-flex justify-center">{{ item.pendingSubscriptions }}</div>
            </template>
            <template v-slot:[`item.subscriptionsWithChargesForNextMonth`]="{ item }">
              <div class="d-flex justify-center">{{ item.subscriptionsWithChargesForNextMonth }}</div>
            </template>
            <template v-slot:[`item.subscriptionsWithFailedCharges`]="{ item }">
              <div class="d-flex justify-center">{{ item.subscriptionsWithFailedCharges }}</div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <DateDetails :name="organizationName"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import DateDetails from "./DateDetails.vue";

export default {
  name: "Subscriptions",
  layout: "Dashboard",
  components: {
    DateDetails,
  },
  data() {
    return {
      loading: false,
      organizationName: '',
      items: [],
      total: 0,
      search: "",
      pagination: {
        sortDesc: [true],
        itemsPerPage: 10,
        page: 1,
      },
      headers: [
        {
          text: this.$t("afrus_engine.table.organization_name"),
          align: "start",
          sortable: false,
          value: "organization_name",
          class: 'text-no-wrap blue--text text--darken-4',
          width: "15%",
        },
        {
          text: this.$t("afrus_engine.table.organization_id"),
          value: "organization_id",
          width: "5%",
          align: 'center',
          class: 'text-no-wrap blue--text text--darken-4',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.activeSubscriptions"),
          value: "activeSubscriptions",
          width: "10%",
          align: 'center',
          class: 'text-no-wrap blue--text text--darken-4',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.effectiveCharges"),
          value: "effectiveCharges",
          width: "10%",
          align: 'center',
          class: 'text-no-wrap blue--text text--darken-4',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.pendingSubscriptions"),
          value: "pendingSubscriptions",
          width: "10%",
          align: 'center',
          class: 'text-no-wrap blue--text text--darken-4',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.subscriptionsWithChargesForNextMonth"),
          value: "subscriptionsWithChargesForNextMonth",
          width: "10%",
          align: 'center',
          class: 'text-no-wrap blue--text text--darken-4',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.subscriptionsWithFailedCharges"),
          value: "subscriptionsWithFailedCharges",
          width: "10%",
          align: 'center',
          class: 'text-no-wrap blue--text text--darken-4',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      stats: "afrusEngine/organizationsStats",
      totalStatsAmount: "afrusEngine/totalStatsAmount",
    }),
    ...mapState({
      languages: ({ auth: { locales } }) => locales,
    }),
  },
  async created() {
    this.readStats();
  },
  methods: {
    ...mapMutations({
      setIsOpenDateStatsDetails: "afrusEngine/setIsOpenDateStatsDetails",
      setDateStats: "afrusEngine/setDateStats",
    }),
    ...mapActions({
      getStats: "afrusEngine/getAllOrganizationStats",
    }),
    async readStats() {
      await this.getStats();
    },
    openDetails(item) {
      this.organizationName = item.organization_name;
      this.setDateStats(item.dateStats);
    },
    async getStatsWithFilters() {
      this.loading = true;
      await this.getStats();
      this.loading = false;
    },
    executeSearch(event) {
      if (event.key === "Enter") {
        this.getStatsWithFilters();
      }
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getStatsWithFilters();
      },
      deep: true,
    },
    stats: {
      handler(value) {
        this.items = value;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.truncateDescription {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.truncateLink {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
